module.exports = __webpack_public_path__ + "static/media/ArchivedFolderWithFolder.af311dd3.svg";